import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ILicenca } from 'src/app/shared/api/licencas/licencas.service';
import { PaginatedResponse } from 'src/app/shared/api/pagination.model';
import { TestesService } from 'src/app/shared/api/testes/testes-cliente.service';
import { ITeste } from 'src/app/shared/api/testes/testes.service';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { TipoTeste, TipoTesteLabels } from 'src/app/shared/model/tipo-teste.enum';

@Component({
    selector: 'listagem-testes-por-tipo',
    templateUrl: './listagem-testes-por-tipo.component.html',
    styleUrls: ['./listagem-testes-por-tipo.component.scss']
})
export class ListagemTestesPorTipoComponent implements OnInit {
    @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef<HTMLDivElement>;

    page = 1;
    pageSize = 10;
    loadingMore = false;
    isAtStart = true;
    isAtEnd = false;

    scrollAmount = 300; // quanto anda por clique

    @Input() tipo!: TipoTeste;
    testes: ITeste[] = [];
    licencas: ILicenca[] = [];
    tipoTesteLabels = TipoTesteLabels;

    tipoTesteEnum = TipoTeste;

    paginacao: PaginatedResponse<any> = { 'total-paginas': 0, pagina: 0, resultados: [], total: 0 };

    filtro: any = {};
    loading = true;

    constructor(
        private testesService: TestesService,
        private router: Router
    ) { }

    ngOnInit(): void {
        // this.customizarMatPaginator();
        this.listarTestes();
    }

    private listarTestes(params = { pagina: 1, tamanho: this.pageSize }) {

        this.filtro.pagina = params.pagina;
        this.filtro.tamanho = params.tamanho;
        this.filtro.antecessor = null;
        this.filtro.tipo = this.tipo;

        this.loading = true;
        this.paginacao.total = 0;

        this.testesService.get(this.filtro).subscribe({
            next: (response) => {
                this.testes.push(...response.resultados);

                this.licencas = [];
                this.testes.forEach(teste => {
                    if (teste.licencas && teste.licencas.length > 0) {
                        this.licencas.push(...teste.licencas);
                    }
                });
                this.paginacao = response;
                this.loading = false;
                this.loadingMore = false;

                setTimeout(() => this.checkPosition(), 200);
            }
        });
    }

    irParaGrupo = (teste: ITeste) => {
        this.goToGrupo(teste.uuid);
    };

    goToGrupo(id: string) {
        this.router.navigate([
            ConstantsRotasDoSistema.DEFAULT_PATH +
            ConstantsRotasDoSistema.GRUPOS_LICENCAS +
            `/${id}`
        ]);
    }

    ngAfterViewInit() {
        this.checkPosition();
    }

    scrollLeft() {
        this.scrollContainer.nativeElement.scrollBy({
            left: -this.scrollAmount,
            behavior: 'smooth'
        });

        setTimeout(() => this.checkPosition(), 300);
    }

    scrollRight() {
        this.scrollContainer.nativeElement.scrollBy({
            left: this.scrollAmount,
            behavior: 'smooth'
        });

        setTimeout(() => {
            this.checkPosition();
            this.tryLoadMore();
        }, 300);
    }

    onScroll() {
        this.checkPosition();
        this.tryLoadMore();
    }

    checkPosition() {
        const el = this.scrollContainer.nativeElement;

        this.isAtStart = el.scrollLeft <= 5;
        this.isAtEnd =
            el.scrollLeft + el.clientWidth >= el.scrollWidth - 5;
    }

    tryLoadMore() {
        if (this.loadingMore) return;
        if (this.testes.length >= this.paginacao.total) return;

        const el = this.scrollContainer.nativeElement;
        const chegouNoFinal =
            el.scrollLeft + el.clientWidth >= el.scrollWidth - 100;

        if (chegouNoFinal) {
            this.carregarMais();
        }
    }

    carregarMais() {
        this.loadingMore = true;
        setTimeout(() => this.scrollRight(), 300);

        this.page++;

        console.log('Carregando página ', this.page);
        this.listarTestes({ pagina: this.page, tamanho: this.pageSize });
    }


    // public alterarPagina(pageEvent: PageEvent) {
    //     const tamanho = pageEvent.pageSize;
    //     const pagina = pageEvent.pageIndex + 1;
    //     this.listarTestes({ tamanho, pagina });
    // }

    // private customizarMatPaginator() {
    //     // protege caso o paginator não exista no template (evita erro que impede renderização)
    //     if (!this.paginator || !this.paginator._intl) {
    //         return;
    //     }

    //     const intl = this.paginator._intl;
    //     intl.itemsPerPageLabel = 'Itens por página';
    //     intl.nextPageLabel = 'Próxima';
    //     intl.previousPageLabel = 'Anterior';
    //     intl.firstPageLabel = 'Primeira página';
    //     intl.lastPageLabel = 'Última página';
    //     intl.getRangeLabel = this.getRangeLabel;
    // }

    // getRangeLabel = (page: number, pageSize: number, length: number) => {
    //     if (length === 0 || pageSize === 0) {
    //         return `0 de ${length}`;
    //     }
    //     length = Math.max(length, 0);
    //     const startIndex = page * pageSize;
    //     const endIndex =
    //         startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    //     const label = `${startIndex + 1} - ${endIndex} de ${length}`;
    //     return label;
    // };

}
